import type { DatePickerToolbarLabels } from "../labels";

type GetToolbarMessageInput = {
  isError: boolean;
  isLoading: boolean;
  isRequestEnabled: boolean;
  labels: DatePickerToolbarLabels;
  usePoints: boolean;
};

export const getToolbarMessage = ({
  isError,
  isLoading,
  isRequestEnabled,
  labels,
  usePoints,
}: GetToolbarMessageInput): string | undefined => {
  if (!isRequestEnabled || isLoading) {
    return undefined;
  }

  const { serviceFail, serviceSuccessCash, serviceSuccessPoints } = labels;

  if (isError) {
    return serviceFail;
  }

  return usePoints ? serviceSuccessPoints : serviceSuccessCash;
};
